// AssistantEducaChat.js

import React, { useState } from "react";
import { GptMessage, MyMessage, TypingLoader, TextMessageBox } from "./index";
import { Assistant_createquestion } from "../../api/AssistantEducaAPI";
import { useAuth } from "../../hooks";

export function AssistantEducaChat({
  assistantId,
  avatarImg,
  saludo,
  threadId,
}) {
  const { accessToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([
    {
      text: `Hola soy ${saludo}. ¿En qué puedo ayudarte?`,
      isGpt: true,
      key: "initial-greeting",
    },
  ]);

  const handlePost = async (text) => {
    if (!threadId) return;

    setIsLoading(true);
    setMessages((prev) => [...prev, { text, isGpt: false }]);

    try {
      // 'response' ahora será el objeto completo: { message: "...", messages: [...] }
      const response = await Assistant_createquestion(
        accessToken,
        threadId,
        assistantId,
        text,
      );
      setIsLoading(false);

      // Extraemos el array de la propiedad 'messages'
      const messagesArray = response?.messages;

      // Verificamos que 'messagesArray' sea realmente un array
      if (Array.isArray(messagesArray)) {
        // Usamos .findLast() para encontrar el último mensaje del asistente
        const lastAssistantReply = messagesArray.findLast(
          (message) => message.role === "assistant",
        );

        if (
          lastAssistantReply &&
          Array.isArray(lastAssistantReply.content) &&
          lastAssistantReply.content.length > 0
        ) {
          const messageText =
            lastAssistantReply.content[lastAssistantReply.content.length - 1];

          setMessages((prev) => [...prev, { text: messageText, isGpt: true }]);
        }
      } else {
        console.error("Respuesta de API inesperada:", response);
        setMessages((prev) => [
          ...prev,
          {
            text: "Ha ocurrido un error al procesar la respuesta.",
            isGpt: true,
          },
        ]);
      }
    } catch (error) {
      console.error("Error al enviar la pregunta:", error);
      setIsLoading(false);
      setMessages((prev) => [
        ...prev,
        {
          text: "No se pudo conectar con el asistente. Inténtalo de nuevo.",
          isGpt: true,
        },
      ]);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-messages">
        <div className="grid grid-cols-12 gap-y-2">
          {messages.map((message, index) =>
            message.isGpt ? (
              <GptMessage
                key={message.key || index}
                text={message.text}
                imageAvatar={avatarImg}
              />
            ) : (
              <MyMessage key={index} text={message.text} />
            ),
          )}
          {isLoading && (
            <div className="col-start-1 col-end-12 fade-in">
              <TypingLoader />
            </div>
          )}
        </div>
      </div>
      <TextMessageBox
        onSendMessage={handlePost}
        placeholder="Escribe aquí tu pregunta..."
        disableCorrections
      />
    </div>
  );
}
